import ReportHorizonSequencingXRef from './ReportHorizonSequencingXRef';

export default class ReportHorizonSequencing {
    id: number;
    clientId?: number;
    projectId?: number;

    // Not mapped
    horizonSequences: ReportHorizonSequencingXRef[];
}


// WEBPACK FOOTER //
// ./src/models/ReportHorizonSequencing.ts